/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

export const getSearchApPayeesMock = () => ({
  ap_payees: Array.from(
    { length: faker.number.int({ min: 10, max: 20 }) },
    (_, i) => i + 1
  ).map(() => ({
    counterparty_name: faker.company.name(),
    id: faker.string.uuid(),
    name: faker.person.fullName(),
  })),
  pagination: {
    has_next_page: true, // Always true for infinite scroll
    has_previous_page: true,
    page: faker.number.int({ min: 1, max: 1000 }),
    per_page: 20,
    total_pages: 1000, // Large number for infinite scroll
    total_records: 20000, // Large number for infinite scroll
  },
});

export const handlers = [
  http.post('*/api/js/ap_payees/search', async () => {
    await delay(500); // Reduced delay for better UX
    return new HttpResponse(JSON.stringify(getSearchApPayeesMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
